import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/external-link-line.svg'


const _hoisted_1 = {
  class: "annotation-card-container",
  tabindex: "0"
}
const _hoisted_2 = { class: "annotation-info" }
const _hoisted_3 = { class: "annotation-title" }
const _hoisted_4 = { style: {"flex":"1"} }
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = {
  key: 0,
  class: "attribution-container"
}
const _hoisted_7 = { class: "legend-icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, null, -1)
const _hoisted_9 = { class: "truncate-text" }
const _hoisted_10 = {
  key: 0,
  class: "quote-container"
}
const _hoisted_11 = { class: "annotation-button-container" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_0,
  alt: "External link"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.data.digitalObjects[0].label ?? _ctx.data.digitalObjects[0].uri), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.datasetIcon != '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.datasetIcon), 1),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.typeLabel ?? _ctx.data.type), 1)
      ]),
      (_ctx.data.quote)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.data.quote), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "annotation-button button-left",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openTarget && _ctx.openTarget(...args))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.openTarget && _ctx.openTarget(...args)), ["enter"]))
      }, [
        _createTextVNode(" Go to mention "),
        _hoisted_12
      ], 32),
      _createElementVNode("button", {
        class: "annotation-button button-right",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectAnnotation && _ctx.selectAnnotation(...args))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.selectAnnotation && _ctx.selectAnnotation(...args)), ["enter"]))
      }, " Details ", 32)
    ])
  ]))
}